import { getModelYears } from '../../../core/utils';
export const isYearOptionDisabled = (models, vehicleType) => {
    if (models.length === 0)
        return true;
    return !models.some((m) => { var _a, _b; return (vehicleType ? (_b = (_a = m === null || m === void 0 ? void 0 : m.filters) === null || _a === void 0 ? void 0 : _a.bodyType) === null || _b === void 0 ? void 0 : _b.includes(vehicleType) : true); });
};
export const isVehicleTypeOptionDisabled = (models, vehicleType, currentOrPreviousYear) => {
    const modelYears = getModelYears(models);
    const currentYear = modelYears[0];
    if (!currentYear)
        return true;
    if (currentOrPreviousYear === 'currentYear') {
        return !models.some(m => { var _a, _b; return ((_b = (_a = m === null || m === void 0 ? void 0 : m.filters) === null || _a === void 0 ? void 0 : _a.bodyType) === null || _b === void 0 ? void 0 : _b.includes(vehicleType)) && m.modelYear === (currentYear === null || currentYear === void 0 ? void 0 : currentYear.toString()); });
    }
    if (currentOrPreviousYear === 'previousYear') {
        return !models.some(m => { var _a, _b; return ((_b = (_a = m === null || m === void 0 ? void 0 : m.filters) === null || _a === void 0 ? void 0 : _a.bodyType) === null || _b === void 0 ? void 0 : _b.includes(vehicleType)) && parseInt(m.modelYear, 10) < currentYear; });
    }
    return !models.some(m => { var _a, _b; return (_b = (_a = m === null || m === void 0 ? void 0 : m.filters) === null || _a === void 0 ? void 0 : _a.bodyType) === null || _b === void 0 ? void 0 : _b.includes(vehicleType); });
};
export const getYearOptions = (yearLabels, activeVehicleType, currentYearModels, previousYearModels) => [
    { text: yearLabels.allYears, value: undefined, disabled: false },
    {
        text: yearLabels.currentYear,
        value: 'currentYear',
        disabled: isYearOptionDisabled(currentYearModels || [], activeVehicleType),
    },
    {
        text: yearLabels.previousYear,
        value: 'previousYear',
        disabled: isYearOptionDisabled(previousYearModels || [], activeVehicleType),
    },
];
export const getVehicleTypeOptions = (modelList, currentOrPreviousYear, bodyTypeFilters) => {
    if (!bodyTypeFilters || !bodyTypeFilters.length)
        return [];
    const options = bodyTypeFilters.flatMap(obj => Object.entries(obj).map(([key, value]) => ({
        text: value,
        value: key,
        disabled: isVehicleTypeOptionDisabled(modelList, key, currentOrPreviousYear),
    })));
    return options;
};
